import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Harish Mullagura',
    title: "Software Developer",
    desciption:"I am a final year student at the Indian Institute of Information Technology, Sri city. I love DSA, Web Development and System Design. I always thrive to learn new technologies.",
    image: 'https://res.cloudinary.com/h2camp/image/upload/v1663489262/samples/95436983_226288808665761_804241742804094096_n_a4dhtc.jpg',
    resumePdf: resume
}
